import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Neo() {
  const canvasRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleKey = (e) => { if (e.key === 'Escape') navigate('/dashboard'); };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [navigate]);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    const resize = () => { canvas.width = window.innerWidth; canvas.height = window.innerHeight; };
    resize();
    window.addEventListener('resize', resize);

    const fontSize = 14;
    let columns = Math.floor(canvas.width / fontSize);
    let drops = Array(columns).fill(0).map(() => Math.random() * -100);

    const chars = 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲン0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ@#$%^&*(){}[]|;:<>?/\\~`+=_-';

    const draw = () => {
      const newCols = Math.floor(canvas.width / fontSize);
      if (newCols !== columns) {
        columns = newCols;
        drops = Array(columns).fill(0).map(() => Math.random() * -100);
      }

      ctx.fillStyle = 'rgba(0, 0, 0, 0.04)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      for (let i = 0; i < drops.length; i++) {
        if (drops[i] < 0) { drops[i] += 0.5; continue; }

        const char = chars[Math.floor(Math.random() * chars.length)];
        const x = i * fontSize;
        const y = drops[i] * fontSize;

        const rand = Math.random();
        if (rand > 0.97) {
          ctx.fillStyle = '#ffffff';
          ctx.font = `bold ${fontSize}px monospace`;
        } else if (rand > 0.85) {
          ctx.fillStyle = '#39ff14';
          ctx.font = `${fontSize}px monospace`;
        } else {
          ctx.fillStyle = `rgba(0, 255, 65, ${0.6 + Math.random() * 0.4})`;
          ctx.font = `${fontSize}px monospace`;
        }

        ctx.fillText(char, x, y);

        if (y > canvas.height && Math.random() > 0.975) {
          drops[i] = Math.random() * -20;
        }
        drops[i] += 0.5 + Math.random() * 0.5;
      }
    };

    const interval = setInterval(draw, 33);

    return () => {
      clearInterval(interval);
      window.removeEventListener('resize', resize);
    };
  }, []);

  return (
    <div
      style={{ position: 'fixed', inset: 0, background: '#000', zIndex: 9999, cursor: 'none' }}
      onClick={() => navigate('/dashboard')}
    >
      <canvas ref={canvasRef} style={{ display: 'block' }} />
      <div style={{
        position: 'absolute', bottom: 30, left: '50%', transform: 'translateX(-50%)',
        color: '#00ff41', fontFamily: 'monospace', fontSize: 11, opacity: 0.2,
      }}>
        ESC or click to exit
      </div>
    </div>
  );
}
